import { render, staticRenderFns } from "./VuesticAlert.vue?vue&type=template&id=f8a48124&scoped=true&"
import script from "./VuesticAlert.vue?vue&type=script&lang=js&"
export * from "./VuesticAlert.vue?vue&type=script&lang=js&"
import style0 from "./VuesticAlert.vue?vue&type=style&index=0&id=f8a48124&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a48124",
  null
  
)

export default component.exports